<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">
             

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Painel de Renda Variável
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Adicionar Ativo -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Novo Ativo do Painel"
                            (click)="openCadastro()">
                        <mat-icon>add_circle</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->
        <!-- / HEADER -->
        
        <mat-card id="custodia-cliente-rv"> 
            <mat-card-header>
                <mat-card-title>Estratégias da Mesa de Renda Variável</mat-card-title>            
            </mat-card-header>

            <mat-card-content>
                <div class="content">
                    <div 
                        fxLayout="column" 
                        fxLayoutAlign="center" 
                        style="margin-bottom: 10px"
                    >
                        <p style="color: red; padding: 10px; font-size: 14px; text-align: justify; background-color: #fff59d;">
                            <b>DISCLAIMER</b>: Essa ferramenta tem como objetivo facilitar o feedback junto ao cliente, 
                            proporcionando o resultado aproximado das operações de Renda Variável,  
                            como referência, utilizamos o preço de custo do ativo + despesas/encargos em geral. Em caso de dúvidas ou divergências ressaltamos que 
                            deve prevalecer a informação oficial das respectivas notas de corretagem. Ressaltamos que, trata-se de informação restrita e sigilosa e sua circulação é
                            terminantemente proibida, sob pena de sanções e severas multas pelo compliance da corretora.
                        </p>
                        
                        <!-- LEGENDA -->
                        <div class="legenda">  
                            <h2 style="float: left; margin-right: 20px;">LEGENDA</h2>
                            <div style="margin-top: 10px;">
                                <div style="height: 40px; float: left; margin-right: 20px;">
                                    <div class="legenda-concluida-positiva"></div> 
                                    <span>Operações concluídas (Positivos)</span>
                                </div>
                                <div style="height: 40px; float: left; margin-right: 20px;">
                                    <div class="legenda-concluida-negativa"></div> 
                                    <span>Operações concluídas (Negativos)</span>
                                </div>
                                <div style="height: 40px; float: left; margin-right: 20px;">
                                    <div class="legenda-aberta"></div> 
                                    <span>Operações Abertas</span>
                                </div>          
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="center">
                        <div 
                            class="filters" 
                            fxLayout="column" 
                            fxLayoutAlign="center center"
                            fxLayout.gt-xs="row" 
                            fxLayoutAlign.gt-xs="center center"
                        >   
                        </div>
                            <div class="course-search">
                                <mat-form-field 
                                    appearance="outline" 
                                    floatLabel="always" 
                                    style="margin-right: 10px;" 
                                >
                                    <mat-label>Data da Operação Início</mat-label>
                                    <input 
                                        matInput 
                                        [matDatepicker]="picker" 
                                        (dateChange) = "getAllEstrategiasPosicaoCliente()"
                                        [formControl]="data_operacao_inicio" 
                                        name="data_operacao_inicio" 
                                        placeholder="Data da Operação"
                                    >
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                        
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Data da Operação Fim</mat-label>
                                    <input 
                                        matInput 
                                        [matDatepicker]="pickerFim" 
                                        [formControl]="data_operacao_fim" 
                                        (dateChange)="getAllEstrategiasPosicaoCliente()"
                                        name="data_operacao_fim" 
                                        placeholder="Data da Operação"
                                    >
                                    <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerFim></mat-datepicker>
                                </mat-form-field> 
                            </div>  
                    </div>
                </div>

                <div id="about" class="p-24" fxLayout="row wrap">            
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let estrategia of listEstrategia">
                            <mat-expansion-panel-header>                                  
                                <mat-panel-title class="titulo-painel-custodia">                
                                    <div style="float: left;">
                                        <span>{{ estrategia.nome.toLocaleUpperCase() }}</span> <br />                                
                                    </div>
                                    <div 
                                        class="cor_estrategia" 
                                        [ngClass]="estrategia.cor_hexadecimal">
                                    </div>
                                </mat-panel-title>
                                <mat-panel-description>
                                    <span class="texto-estrategia">
                                        <span>Quantidade de Trades (Abertos):</span><br/>
                                        <span class="text-alinhado-centralizado">
                                            <b>{{ estrategia.total_trades_abertos | number : '1.0-0' }}</b> 
                                        </span>
                                    </span> |
                                    <span class="texto-estrategia">
                                        <span>Quantidade de Trades (Fechados):</span><br/>
                                        <span class="text-alinhado-centralizado">
                                            <b>{{ estrategia.total_trades_fechados | number : '1.0-0' }}</b> 
                                        </span>
                                    </span> |
                                    <span 
                                        class="texto-estrategia" 
                                        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
                                    >
                                        <span>Total Movimentado (R$):</span><br />
                                        <span>
                                            <b>R$ {{ estrategia.total_volume_efetivado | number : '1.2-2'}}</b>
                                        </span> 
                                    </span> | 
                                    <span 
                                        class="texto-estrategia" 
                                        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
                                    >
                                        <span>Custódia Hoje (D-1):</span> <br/>
                                        <span>
                                            <b>R$ {{ estrategia.custodia_estrategia | number : '1.2-2' }}</b>
                                       </span> 
                                    </span> 
                                </mat-panel-description>                     
                            </mat-expansion-panel-header>
                            
                            <ng-template matExpansionPanelContent>
                                <itens-painel 
                                    [estrategia_id]="estrategia.id"
                                    [data_inicio]="data_operacao_inicio.value || currentDate"
                                    [data_fim]="data_operacao_fim.value || currentDate"
                                    (refreshEvent)="refreshItem($event)"
                                >
                                </itens-painel>
                            </ng-template>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </mat-card-content>
        </mat-card>
        
    </div>
</div>